import React from 'react';
import MainLayout from '../components/Layout/MainLayout';
import DoctorList from '../components/Doctors/DoctorList';

const DoctorsPage = () => (
  <MainLayout><DoctorList /></MainLayout>
);

export default DoctorsPage;